/** The integration's key: its registry key, and the type of its requests. */
export const REDSHIFT_AI_INTEGRATION_KEY = "redshift-ai" as const;

/**
 * The connector's Lambda function name, which is also its image name. The
 * install Terraform deploys the connector under it, and P0 invokes it by it.
 */
export const REDSHIFT_AI_CONNECTOR_FUNCTION_NAME =
  "p0-connector-redshift-ai-aws";

/** Every grant's IAM role is on this path, so an account admin can find
 * them, and the AWS integration's role listing can tell them apart. The
 * connector's Terraform lets P0 manage roles on it, and no others. */
export const AGENT_ROLE_PATH = "/p0/redshift-ai/";
